var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowNegativeResult(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2498_21973)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.16,
    cx: 12,
    cy: 12,
    r: 12,
    transform: "rotate(90 12 12)",
    fill: "#FF485E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3333 18.0002C15.3798 18.0065 15.4269 18.0065 15.4733 18.0002C15.5125 17.9944 15.5506 17.9832 15.5867 17.9669C15.6192 17.9493 15.6504 17.9292 15.68 17.9069C15.7222 17.8815 15.7604 17.8501 15.7933 17.8135L15.84 17.7335C15.8687 17.6951 15.8912 17.6523 15.9067 17.6069L15.9067 17.4735C15.946 17.4329 15.9776 17.3855 16 17.3335L16 14.0002C16 13.632 15.7015 13.3335 15.3333 13.3335C14.9651 13.3335 14.6667 13.632 14.6667 14.0002L14.6667 15.8869L11.5267 13.2202L13.24 10.3402C13.4076 10.0584 13.3454 9.69654 13.0933 9.48687L9.09333 6.15353C8.95728 6.04016 8.7817 5.98558 8.60535 6.00184C8.429 6.0181 8.26636 6.10386 8.15333 6.2402C8.05394 6.36014 7.99969 6.5111 8 6.66687C7.99968 6.86515 8.08764 7.05329 8.24 7.1802L11.8 10.1469L10.0933 12.9935C9.92801 13.2723 9.98708 13.6295 10.2333 13.8402L13.5333 16.6669L12 16.6669C11.6318 16.6669 11.3333 16.9653 11.3333 17.3335C11.3333 17.7017 11.6318 18.0002 12 18.0002L15.3333 18.0002Z",
    fill: "#FF485E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2498_21973"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(24) rotate(90)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowNegativeResult);
export default __webpack_public_path__ + "static/media/arrowNegativeResult.e6179b614df66c593d9be561c00fadac.svg";
export { ForwardRef as ReactComponent };